<template>
  
    <section id="testimonials" class="testimonials">
    <div class="container" data-aos="fade-up">
      <div class="section-title">
        <h2>نظرات مشتریان</h2>
        <p>
          در این قسمت نظرات مشتریان را برای شما فراهم کرده ایم تا گروه صنعتی سبلان میکسر
          را بهتر بشناسید .
        </p>
      </div>

      <div
        class="testimonials-slider swiper"
        data-aos="fade-up"
        data-aos-delay="100"
      >
        <div class="swiper-wrapper">

          <div  v-for="item in contentListByCategoryComments" :key="item.id" class="swiper-slide">            
            <div class="testimonial-item">
              <div>
                <i class="bx bxs-quote-alt-right quote-icon-right"></i>
                 <div v-html="item.des"></div>
                <br />
                <i class="bx bxs-quote-alt-left quote-icon-left"></i>
              </div>
              <img
                src="/assets/img/testimonials/avatar.png"
                class="testimonial-img"
                alt=""
              />
              <h3>
                   {{ item.title }}
              </h3>
              <h4>...</h4>
            </div>
          </div>


        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import TextEditor from "@/components/TextEditor.vue";
import Alerts from "@/components/Alerts";
import { dataGridMixin } from "@/components/dataGridMixin";
import Swal from "sweetalert2";

export default {
  components: {
    TextEditor,
    Alerts,
  },
  mixins: [dataGridMixin],
  computed: {
    ...mapGetters({
      contentListByCategoryComments: "controlPanelX/contentListByCategoryComments",
    }),
  },
  data() {
    return {};
  },
  watch: {
    currentUser() {
      if (this.currentUser != undefined) {
        this.loadData();
      }
    },
  },
  methods: {},
  async created() {
    await this.$store.dispatch(
      "controlPanelX/getContentListByCategoryTitle",
      "Comments"
    );
  },
  mounted() {},
};
</script>

<style>
</style>